import { render, staticRenderFns } from "./SectionProducts.vue?vue&type=template&id=5e1df4bf&scoped=true&"
import script from "./SectionProducts.vue?vue&type=script&lang=js&"
export * from "./SectionProducts.vue?vue&type=script&lang=js&"
import style0 from "./SectionProducts.vue?vue&type=style&index=0&id=5e1df4bf&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e1df4bf",
  null
  
)

export default component.exports